/*=========================================================================================
  File Name: mutations.js
  Namespace: users
  Description: Vuex Store - User mutations
==========================================================================================*/
import { stateBuilder } from './state'
import cloneDeep from 'lodash.clonedeep'

const mutations = {
  initializeUser(state) {
    state.currentUser = stateBuilder()
  },
  setUser(state, payload) {
    state.currentUser = {
      ...state.currentUser,
      ...cloneDeep(payload)
    }
  },
  setTokenToStore(state, {token} ) {
    state.currentUser.token = token
  },
}

export default mutations
